// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay-component--layout {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  width: 0px;\n  height: 0px;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 10;\n  overflow: hidden; }\n  .overlay-component--layout.overlay-component--open {\n    width: 100vw;\n    height: 100vh; }\n  .overlay-component--layout .overlay-component--content {\n    width: fit-content;\n    height: fit-content; }\n", ""]);
// Exports
module.exports = exports;
